import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect, FormSelectProps, SelectOption } from '../../../..';

export const FormLanguageSelect: FC<Omit<FormSelectProps, 'options'>> = (props) => {
  const { t } = useTranslation();

  const lngs: Array<SelectOption> = ['de', 'en'].map((lng) => ({
    value: lng,
    text: t('common:LANGUAGE', { context: lng })
  }));

  return (
    <FormSelect
      options={lngs}
      label={t('common:LANGUAGE')}
      placeholder={t('common:LANGUAGE')}
      {...props}
    />
  );
};
